module.exports = __webpack_public_path__ + "static/img/mellars-haizyn.d8600aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mellars-haizyn.jpg
// module id = xRF2
// module chunks = 0